import CartSinglePageUpdateEmail from './CartSinglePageUpdateEmail'

export default CartSinglePageUpdateEmail
// eslint-disable-next-line import/export
export * from './CartSinglePageUpdateEmail'
